export default __webpack_public_path__ + "static/media/Interiores4.80b6505a.jpeg";